@let title = isEmail() ? ("email.title" | translate) : ("pdfHandler.title" | translate);
<h2 mat-dialog-title data-testid="actions-dialog-title">{{ title }}</h2>

<mat-dialog-content fxLayout="column" fxLayoutGap="16px">
    <div fxLayout="column" class="p-t-lg">
        @let showBundleOption = !isPrint() && data.entityInstances.length >= 2;
        @if (showBundleOption) {
            <mat-checkbox
                data-testid="actions-dialog-bundle"
                [disabled]="isLoading()"
                [checked]="isBundleDocuments()"
                (change)="onOptionChange(isBundleDocuments.set.bind(isBundleDocuments), $event.checked)">
                {{ "pdfHandler.bundleDescription" | translate }}
            </mat-checkbox>
        }

        <mat-checkbox
            data-testid="actions-dialog-include-activity"
            [disabled]="isLoading()"
            [checked]="isIncludeActivity()"
            (change)="onOptionChange(isIncludeActivity.set.bind(isIncludeActivity), $event.checked)">
            {{ "pdfHandler.includeActivityDescription" | translate }}
        </mat-checkbox>

        <mat-checkbox
            data-testid="actions-dialog-include-document-attachments"
            [disabled]="isLoading()"
            [checked]="isIncludeDocumentAttachments()"
            (change)="
                onOptionChange(isIncludeDocumentAttachments.set.bind(isIncludeDocumentAttachments), $event.checked)
            ">
            {{ "pdfHandler.includeDocumentAttachmentsDescription" | translate }}
        </mat-checkbox>

        <mat-checkbox
            data-testid="actions-dialog-include-activity-attachments"
            [disabled]="isLoading()"
            [checked]="isIncludeActivityAttachments()"
            (change)="
                onOptionChange(isIncludeActivityAttachments.set.bind(isIncludeActivityAttachments), $event.checked)
            ">
            {{ "pdfHandler.includeActivityAttachmentsDescription" | translate }}
        </mat-checkbox>
    </div>

    @if (showTemplates()) {
        @if (isTemplatesLoading()) {
            <ngx-skeleton-loader
                data-testid="actions-dialog-template-skeleton"
                [theme]="{ width: '100%', height: '56px', margin: '0' }" />
        } @else {
            <mat-form-field appearance="outline" data-testid="actions-dialog-template">
                <mat-label>{{ "pdfHandler.template" | translate }}</mat-label>
                <mat-select
                    [disabled]="isLoading()"
                    [ngModel]="selectedTemplateId()"
                    (ngModelChange)="selectedTemplateId.set($event)">
                    @for (template of templates(); track template.key) {
                        <mat-option
                            [value]="template.key"
                            [attr.data-testid]="
                                'actions-dialog-template-option' +
                                (template.isPrimary ? ' actions-dialog-template-default' : '')
                            ">
                            {{ template.value }} {{ template.isPrimary ? "(default)" : "" }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
    }

    @if (printWarningBanner() === "sizeLimit") {
        <div
            role="alert"
            data-testid="actions-dialog-print-size-warning"
            class="p-md"
            style="border: 1px solid #f0ad4e; background-color: #fcf8e3; border-radius: 4px; color: #8a6d3b">
            {{ "pdfHandler.printSizeLimitFallbackMessage" | translate }}
        </div>
    }

    @if (printWarningBanner() === "unsupported") {
        <div
            role="alert"
            data-testid="actions-dialog-unsupported-warning"
            fxLayout="column"
            fxLayoutGap="8px"
            class="p-md"
            style="border: 1px solid #f0ad4e; background-color: #fcf8e3; border-radius: 4px; color: #8a6d3b">
            <div>
                {{
                    "pdfHandler.printUnsupportedWarning"
                        | translate: { count: printValidationResult()?.unsupportedCount || 0 }
                }}
            </div>

            @if (showUnsupportedReview()) {
                <div
                    data-testid="actions-dialog-unsupported-list"
                    class="p-t-sm"
                    style="max-height: 180px; overflow-y: auto">
                    @for (group of excludedAttachmentsGrouped(); track group.documentNumber) {
                        <div class="m-b-xs">
                            <strong>{{ group.documentNumber }}</strong>
                            <ul class="m-t-xs m-b-xs">
                                @for (item of group.items; track item.fileName + item.category) {
                                    <li data-testid="actions-dialog-unsupported-item">
                                        {{ item.fileName }} ({{ item.category }}) —
                                        {{ getReasonTranslationKey(item.reason) | translate }}
                                    </li>
                                }
                            </ul>
                        </div>
                    }
                </div>
            }
        </div>
    }
</mat-dialog-content>

@let confirmLabel =
    isEmail()
        ? ("email.proceed" | translate)
        : isPrint()
          ? ("pdfHandler.print" | translate)
          : ("pdfHandler.download" | translate);
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close data-testid="actions-dialog-action-cancel">
        {{ (isLoading() ? "general.close" : "pdfHandler.cancel") | translate }}
    </button>
    @if (printWarningBanner() === "unsupported") {
        <button
            mat-stroked-button
            type="button"
            data-testid="actions-dialog-review-unsupported-btn"
            (click)="onToggleUnsupportedReview()">
            {{ "pdfHandler.reviewUnsupportedFiles" | translate }}
        </button>
        <button
            mat-stroked-button
            type="button"
            data-testid="actions-dialog-switch-download-btn"
            (click)="onSwitchToDownload()">
            {{ "pdfHandler.download" | translate }}
        </button>
        <button
            mat-flat-button
            color="primary"
            type="button"
            data-testid="actions-dialog-continue-print-btn"
            [disabled]="isLoading()"
            (click)="onContinuePrintAnyway()">
            {{ "pdfHandler.continuePrint" | translate }}
        </button>
    } @else {
        <button
            mat-flat-button
            color="primary"
            data-testid="actions-dialog-action-confirm"
            (click)="onConfirm()"
            [disabled]="isLoading() || !selectedTemplateId()">
            <span fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                @if (isLoading()) {
                    <mat-spinner diameter="16" data-testid="actions-dialog-confirm-spinner" />
                }
                <span>{{ isLoading() ? (preparingLabelKey() | translate) : confirmLabel }}</span>
            </span>
        </button>
    }
</mat-dialog-actions>
